<div class="header-label">
  <h2>Notifications</h2>
</div>

<div class="top-controls-row">
  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Search by Email</mat-label>
    <input
      matInput
      [value]="searchTerm"
      (input)="onSearch(($any($event.target)).value)"
      placeholder="Type to search..."
      autocomplete="off"/>
    <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  <button mat-flat-button color="primary" type="button" class="top-controls-action-btn" (click)="openNew()">Add New Email</button>
</div>

<div *ngIf="errorMessage" class="api-error-banner">
  {{ errorMessage }}
</div>

<div class="table-loader" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="table-wrapper" [class.loading]="loading" [hidden]="!clientId">

  <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir" class="demo-table">

    <!-- Email -->
    <ng-container matColumnDef="recipient">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="recipient">Email</th>
      <td mat-cell *matCellDef="let element">{{ element.recipient }}</td>
    </ng-container>

    <!-- ETL Success -->
    <ng-container matColumnDef="onETLSuccess">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="onETLSuccess">On ETL Success</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon color="primary" *ngIf="element.onETLSuccess">check</mat-icon>
      </td>
    </ng-container>

    <!-- ETL Failure -->
    <ng-container matColumnDef="onETLFailure">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="onETLFailure">On ETL Failure</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon color="warn" *ngIf="element.onETLFailure">check</mat-icon>
      </td>
    </ng-container>

    <!-- URF Receipt -->
    <ng-container matColumnDef="onURFReceipt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="onURFReceipt">URF Receipt</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon color="accent" *ngIf="element.onURFReceipt">check</mat-icon>
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="no-header"></th>
      <td mat-cell *matCellDef="let row" class="actions-cell">
        <button
          mat-icon-button
          aria-label="Edit"
          (click)="openEdit(row); $event.stopPropagation()"
          matTooltip="Edit"
          class="table-action-btn table-action-edit">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div *ngIf="dataSource.data.length === 0" class="no-results-message">
    No notifications found
  </div>
</div>

<mat-paginator
  [length]="totalCount"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10, 20, 50]"
  (page)="onPageChange($event)"
  showFirstLastButtons>
</mat-paginator>

<!-- Modal -->
<ng-template #notificationDialog>
  <h2 mat-dialog-title>{{ isEdit ? 'Edit Notification' : 'New Notification' }}</h2>
  
  <form #notifForm="ngForm" (ngSubmit)="save(notifForm)">
    <mat-dialog-content>
      <div *ngIf="dialogError" class="api-error-banner" style="margin-bottom: 8px;">{{ dialogError }}</div>
      <mat-form-field appearance="outline" class="email-input">
        <mat-label>Email</mat-label>
        <input
          matInput
          type="email"
          name="recipientEmail"
          [(ngModel)]="model.recipient"
          required
          email
          #recipientField="ngModel"
        />
        <mat-error *ngIf="recipientField.hasError('required')">Email is required.</mat-error>
        <mat-error *ngIf="recipientField.hasError('email')">Please enter a valid email address.</mat-error>
      </mat-form-field>

      <mat-checkbox [(ngModel)]="model.onETLSuccess" name="onETLSuccess">On ETL Success</mat-checkbox>
      <mat-checkbox [(ngModel)]="model.onETLFailure" name="onETLFailure">On ETL Failure</mat-checkbox>
      <mat-checkbox [(ngModel)]="model.onURFReceipt" name="onURFReceipt">URF Receipt</mat-checkbox>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-flat-button color="primary" type="submit">Submit</button>
      <button mat-stroked-button type="button" (click)="closeDialog()">Cancel</button>
    </mat-dialog-actions>
  </form>
</ng-template>